import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./hooks/useAuth";
import { OfflineBanner } from "./hooks/useOfflineStatus";
import { LanguageProvider } from "./hooks/useLanguage";
import { InstallButton } from "./components/pwa/InstallButton";
import Platform from "./pages/Platform";
import LoupGarou from "./pages/LoupGarou";
import Impro from "./pages/Impro";
import Tribunal from "./pages/Tribunal";
import AppelAbsurde from "./pages/AppelAbsurde";
import MurderMystery from "./pages/MurderMystery";
import RpgIA from "./pages/RpgIA";
import StartupPitch from "./pages/StartupPitch";
import Auth from "./pages/Auth";
import Profile from "./pages/Profile";
import Leaderboards from "./pages/Leaderboards";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <AuthProvider>
          <TooltipProvider>
            <OfflineBanner />
            <InstallButton />
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Platform />} />
                <Route path="/loup-garou" element={<LoupGarou />} />
                <Route path="/impro" element={<Impro />} />
                <Route path="/tribunal" element={<Tribunal />} />
                <Route path="/appel-absurde" element={<AppelAbsurde />} />
                <Route path="/murder-mystery" element={<MurderMystery />} />
                <Route path="/rpg-ia" element={<RpgIA />} />
                <Route path="/startup-pitch" element={<StartupPitch />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/leaderboards" element={<Leaderboards />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </TooltipProvider>
        </AuthProvider>
      </LanguageProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
